// Droits sur ses propres données : export et suppression définitive (RGPD).
import Store from "../store.js";
import { esc, toast, modale, fermerModale } from "../ui.js";

/** Télécharge tout ce que le membre a produit, dans un fichier JSON. */
export async function exporterMesDonnees(ctx) {
  toast("Préparation de vos données…");
  try {
    const donnees = await Store.compte.exporter();
    const fichier = new Blob([JSON.stringify(donnees, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(fichier);
    const lien = document.createElement("a");
    lien.href = url;
    lien.download = `koinonia-${(ctx.moi.nom || "membre").toLowerCase().replace(/\s+/g, "-")}-${new Date().toISOString().slice(0, 10)}.json`;
    lien.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    toast("Vos données ont été téléchargées");
  } catch (e) {
    toast(e.message || "Export impossible", "erreur");
  }
}

const MOT_DE_CONFIRMATION = "SUPPRIMER";

/**
 * Suppression définitive. On demande d'écrire un mot exact : un compte ne doit
 * pas pouvoir disparaître sur un clic malheureux.
 */
export function supprimerMonCompte(ctx) {
  const { el } = modale({
    titre: "Supprimer mon compte",
    corps: `
      <p>Cette action est <strong>définitive</strong>. Seront effacés :</p>
      <ul class="details" style="margin:12px 0">
        <li>votre profil, votre photo et votre couverture</li>
        <li>vos publications, commentaires et statuts</li>
        <li>vos amens, vos amitiés et vos blocages</li>
        <li>vos notifications</li>
      </ul>
      <p class="texte-doux petit">Vos messages privés sont conservés pour les personnes avec qui vous
      avez échangé — ils leur appartiennent aussi — mais ils deviendront anonymes.</p>
      <p class="texte-doux petit">Pensez à <strong>télécharger vos données</strong> avant de continuer.</p>
      <label class="label">Pour confirmer, écrivez <strong>${MOT_DE_CONFIRMATION}</strong>
        <input class="champ" id="mot-confirmation" autocomplete="off" placeholder="${MOT_DE_CONFIRMATION}">
      </label>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Supprimer définitivement",
        classe: "btn--danger",
        onClick: async (fond) => {
          const saisi = fond.querySelector("#mot-confirmation").value.trim().toUpperCase();
          if (saisi !== MOT_DE_CONFIRMATION) return toast(`Écrivez ${MOT_DE_CONFIRMATION} pour confirmer`, "erreur");
          const bouton = fond.querySelector('[data-action="1"]');
          bouton.disabled = true;
          bouton.textContent = "Suppression…";
          try {
            await Store.compte.supprimer();
            fermerModale();
            location.hash = "#/fil";
            toast("Votre compte a été supprimé. Que Dieu vous garde 🕊️");
          } catch (e) {
            bouton.disabled = false;
            bouton.textContent = "Supprimer définitivement";
            const recent = /recent|login/i.test(e.message || "");
            toast(
              recent
                ? "Par sécurité, reconnectez-vous puis recommencez."
                : e.message || "Suppression impossible",
              "erreur"
            );
          }
        },
      },
    ],
  });
  el.querySelector("#mot-confirmation").focus();
}
